var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tooltip',{ref:"tooltip",attrs:{"content":_vm.content,"theme":_vm.theme,"placement":_vm.placementPosition}},[_vm._t("label"),_vm._v(" "),_vm._t("content",null,{"slot":"content"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }